import { React, useEffect } from "react";
import {
  Container,
  Grid,
  GridColumn,
  GridRow,
  Header,
  Image,
} from "semantic-ui-react";
import Faq from "./faq";
import ContactForm from "./contactForm";

export default function ContactUs() {
  useEffect(() => {
    document.title = "Contact Custom Metal Tas | Metal Fabrication Inquiries, Launceston";
    document.querySelector('meta[name="description"]').setAttribute("content", "Contact Custom Metal Tas for metal fabrication inquiries in Launceston. Get in touch for custom metalwork, welding, and repair services. Ask us any questions!");
  }, []);

  const h1Style = {
    fontFamily: "'B612', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    fontSize: "clamp(3em, 4vw, 4em)",
  };

  const h2Style = {
    ...h1Style,
    fontSize: "clamp(2.7em, 3.5vw, 3.7em)",
    padding: "0em 0em 0.5em 0em",
  };

  const pStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    fontSize: "clamp(1.1em, 1vw, 1.4em)",
    lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  };

  return (
    <main>
      <Grid aria-label="Contact Us Header">
        <GridRow
          style={{
            position: "relative",
            width: "100vw",
            overflow: "hidden",
            margin: "-7em 0em 0em 0em",
            height: "20em",
            backgroundImage: "url('./contactUsHeader.webp')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
          }}
        >
          <GridColumn
            verticalAlign="bottom"
            style={{
              padding: "0em 0em 3em 5em",
              maxWidth: "100em",
              textAlign: "left",
            }}
          >
            <Header as="h1" content="Contact Us" style={h1Style} />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid style={{ padding: "10em 5% 10em 5%" }} aria-label="Contact Details">
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn textAlign="Left">
            <Container>
              <Header as="h2" content="Contact Details" style={h2Style} />
            </Container>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn textAlign="Left">
            <Container style={pStyle}>Email: <a style={pStyle} href="mailto:custommetaltas@gmail.com">custommetaltas@gmail.com</a></Container>
            <br />
            <Container style={pStyle}>Phone: <a style={pStyle} href="tel:0456177170">0456 177 170</a></Container>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid style={{ padding: "10em 5% 10em 5%" }} aria-label="Frequently Asked Questions">
        <GridRow>
          <GridColumn>
            <Container>
              <Header as="h2" content="Frequently Asked Questions" style={h2Style} />
              <Faq />
            </Container>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image src="./topBreak.svg" alt="Decorative top break" />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid style={{ padding: "5em 5% 5em 5%", backgroundColor: "#212121" }} aria-label="Contact Form">
        <GridRow>
          <GridColumn>
            <ContactForm />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image src="./bottomBreak.svg" alt="Decorative bottom break" loading="lazy"/>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image src="./topBreak.svg" alt="Decorative top break" loading="lazy"/>
          </GridColumn>
        </GridRow>
      </Grid>
    </main>
  );
}